import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../FeralScan.dtos";
import { IAppState } from '../../../../app';
import { IBasePageProps } from '../../configuration/IConfiguration';
import PasswordReset from '../../../Users/PasswordReset';

interface IPagePasswordResetProps {
    passwordResetBody: any;
}

interface IPagePasswordResetRouteParams {
}

interface IPagePasswordResetQueryParams {
    changePasswordToken: string;
}

interface IPagePasswordResetListMapped {
}

type PagePasswordResetProps = IBasePageProps<IPagePasswordResetRouteParams, IPagePasswordResetQueryParams> & IPagePasswordResetListMapped & IPagePasswordResetProps;

class PagePasswordReset extends React.Component<PagePasswordResetProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <PasswordReset
                currentUser={this.props.currentUser}
                loginActive={this.props.loginActive}
                changePasswordToken={this.props.queryParams.changePasswordToken}
                children={this.props.passwordResetBody}
            />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PagePasswordResetProps) => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PagePasswordReset);